import { ModalComponent } from './modal/modal.component';
import { StepperComponent } from './stepper/stepper.component';
import { TabsComponent } from './tabs/tabs.component';
import { TituloSectionComponent } from './titulo-section/titulo-section.component';
import { UnidadDetailComponent } from './unidad-detail/unidad-detail.component';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BtnUploadFilesComponent } from './btn-upload-files/btn-upload-files.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalTakePhotosComponent } from './modal-take-photos/modal-take-photos.component';
import { WebcamModule } from 'ngx-webcam';
import { ErrSSEComponent } from './err-sse/err-sse.component';
import { QuoterComponentsModule } from 'src/app/components/quotercomponents.module';
import { StatusTitleComponent } from './status-title/status-title.component';
import { UnidadDetailOptionsComponent } from './unidad-detail-options/unidad-detail-options.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UpdateContactsComponent } from './update-contacts/update-contacts.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UnidadDetailModalComponent } from './unidad-detail-modal/unidad-detail-modal.component';
import { CounterComponent } from './counter/counter.component';
import { MifielComponent } from './mifiel/mifiel.component';
import { AddressComponent } from './address/address.component';
import { SignatureStatusComponent } from './signature-status/signature-status.component';
import { AddressCreditrequestComponent } from './address-creditrequest/address-creditrequest.component';
import { IdentityVerificationComponent } from './identity-verification/identity-verification.component';
import { IdentityOptionsComponent } from './identity-verification/identity-options/identity-options.component';


@NgModule({
  declarations: [
    ModalComponent,
    StepperComponent,
    TabsComponent,
    TituloSectionComponent,
    UnidadDetailComponent,
    BtnUploadFilesComponent,
    ModalTakePhotosComponent,
    ErrSSEComponent,
    StatusTitleComponent,
    UnidadDetailOptionsComponent,
    UpdateContactsComponent,
    UnidadDetailModalComponent,
    CounterComponent,
    MifielComponent,
    AddressComponent,
    AddressCreditrequestComponent,
    SignatureStatusComponent,
    IdentityVerificationComponent,
    IdentityOptionsComponent
  ],
  imports: [
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxQRCodeModule,
    MatButtonModule,
    FormsModule,
    WebcamModule,
    QuoterComponentsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    CommonModule
  ],
  exports: [
    ModalComponent,
    StepperComponent,
    TabsComponent,
    TituloSectionComponent,
    UnidadDetailComponent,
    BtnUploadFilesComponent,
    ErrSSEComponent,
    StatusTitleComponent,
    UnidadDetailOptionsComponent,
    AddressComponent,
    AddressCreditrequestComponent,
    SignatureStatusComponent,
    IdentityVerificationComponent,
    IdentityOptionsComponent
  ],
  providers: [
    { provide: 'Window', useValue: window }
  ]
})
export class ComponentsModule { }
